<template>
  <div class="container mt-4">
    <b-container>
      <b-row style="text-align: left">
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Nome / CPF:</span>
            <span style="margin-left: 5px"
              >{{ aposentadoria.NmAposentado }} -
              {{ aposentadoria.NrCpf }}</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">RG / Órgão Emissor:</span>
            <span style="margin-left: 5px"
              >{{ aposentadoria.NrRg }} -
              {{ aposentadoria.DeOrgaoEmissorRg }}</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Data de Nascimento:</span>
            <span style="margin-left: 5px">{{
              formatData(aposentadoria.DtNascimento)
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Sexo:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.DeSexo === "F"
                ? "Feminino"
                : aposentadoria.DeSexo === "M"
                ? "Masculino"
                : "Outro"
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Cargo:</span>
            <span style="margin-left: 5px">{{ aposentadoria.DeCargo }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Órgão de Aposentadoria:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.DeOrgaoAposentadoria
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Regra de Transição:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.IdRegraTransicaoNavigation?.DeRegraTransicao
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Enquadramento:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.DeEnquadramento
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Faltas e/ou Suspensões:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.NrDiasFalta
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Majoração:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.NrDiasMajoracao
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Compensação:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.FlCompensacao === true ? "Sim" : "Não"
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Data do Requerimento:</span>
            <span style="margin-left: 5px">{{
              formatData(aposentadoria.DtRequerimento)
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Ano/Número da Portaria:</span>
            <span style="margin-left: 5px"
              >{{ aposentadoria.AnoPortaria }}/{{
                aposentadoria.NrPortaria
              }}</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Data da Portaria:</span>
            <span style="margin-left: 5px">{{
              formatData(aposentadoria.DtPortaria)
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Protocolo E-tce:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.CdProtocoloTce
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Data de Envio:</span>
            <span style="margin-left: 5px">{{
              formatData(aposentadoria.DtCriacao)
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <span style="font-weight: bold">Situação:</span>
            <span style="margin-left: 5px">{{
              aposentadoria.DtExclusao == "" ? "Ativo" : "Cancelado"
            }}</span>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6" v-if="aposentadoria.DtExclusao != ''">
          <b-form-group>
            <span style="font-weight: bold"
              >Data de Exclusão / CPF Exclusão:</span
            >
            <span style="margin-left: 5px"
              >{{ formatData(aposentadoria.DtExclusao) }} -
              {{ aposentadoria.CpfExclusao }}</span
            >
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue, Watch } from "vue-property-decorator";
import { PropType } from "vue";
import { Aposentadoria } from "@/types/aposentadoria/aposentadoria";

const CompProps = Vue.extend({
  name: "AbaDadosIniciais",
  props: {
    aposentadoria: {
      type: Object as PropType<Aposentadoria>,
      required: true,
    },
  },
});

@Component
export default class AbaDadosIniciais extends mixins(UtilsTS, CompProps) {
  //Variáveis para overlays
  carregandoListaArquivos = false;

  //computeds
  mounted() {
    // console.log(this.aposentadoria);
  }
}
</script>
